document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, "") + "js"

if (window.location.hash) { setTimeout(function () { 
    console.log("hash");
    window.scrollTo(0, 0); 
    var target = window.location.hash;
    var $target = jQuery(target);

    if($target == "#") return;

    jQuery('html, body').stop().animate({
        'scrollTop': $target.offset().top - 50
    }, 1200, 'swing', function () {
        window.location.hash = target;
    });
}, 2); }

jQuery(document).ready(function ($) {

    /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/

    //Load images, and images after doc ready
    var lazyLoadImages = (function () {
        var $lazyImages = $('img[data-src], iframe[data-src], [data-background]');
        if (!$lazyImages.length) { return; }

        function init() {
            $lazyImages.each(function () {
                var $this = $(this),
                    delay = 0,
                    dataSrc;
                if (dataSrc = $this.data('background')) {
                    if ($this.data('background-delay')) {
                        delay = $this.data('background-delay');
                    }
                    setTimeout(function () {
                        $this.css('background-image', 'url(' + dataSrc + ')');
                        $this.attr('data-background', null);
                    }, delay);
                } else if (dataSrc = $this.data('src')) {
                    if ($this.data('src-delay')) {
                        delay = $this.data('src-delay');
                    }
                    setTimeout(function () {
                        $this.attr('src', dataSrc);
                        $this.attr('data-src', null);
                    }, delay);
                }
            });
        }
        init();
        return { init: init }
    }());

    //Global function to toggle simple accordions
    var Accordions = (function () {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        $accordions.each(function () {
            $this = $(this).find('.accordion__trigger');
            if ($this.hasClass('active')) {
                $this.next().slideToggle(250);
            }
        });
        $(document).on('click', '.accordion__trigger', function () {
            var $this = $(this);
            $this.toggleClass('active');
            $this.next().slideToggle(250);
            $this.parent().siblings().find('.accordion__trigger').removeClass('active').next().slideUp(250);
        });
    }());

    var Forms = (function () {
        var InputMasks = (function () {
            var $masks = $('[data-mask]');
            if ( !$masks.length ) { return; }

            /**
             * Key Codes:
             * 8    - backspace
             * 13   - enter
             * 16   - shift
             * 18   - alt
             * 20   - caps
             * 27   - esc
             * 37   - left arrow
             * 38   - up arrow
             * 39   - right arrow
             * 40   - down arrow
             * 46   - delete
             **/
            var exclude_keys = [ 8, 13, 16, 18, 20, 27, 37, 38, 39, 40, 46 ];

            $( '[data-mask]' ).keyup( function ( e ) {
                console.log( e.keyCode );
                if ( exclude_keys.indexOf( e.keyCode ) > -1 ) { return; }

                switch ( this.dataset.mask ) {
                    case 'digits':
                        var x = this.value.replace( /\D/g, '' );
                        this.value = x;
                        break;
                    case 'phone':
                        var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        console.log(x);
                        this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                        break;
                    case 'ssn': {
                        var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                    }
                }
            });
        }());

        //Plugin used for form validation
        var parselyOptions = {
            classHandler: function (parsleyField) {
                var $element = parsleyField.$element;
                if ($element.parent().hasClass('select-menu')) {
                    return $element.parent();
                }
                return $element;
            },
            errorsContainer: function (parsleyField) {
                var $element = parsleyField.$element;
                var $fieldContainer = $element.closest('.form-field');
                if ($fieldContainer) {
                    return $fieldContainer;
                }
            }
        };

        //Global function to set form state classes
        var formStates = (function () {
            $formInputs = $('main form :input');
            if (!$formInputs.length) { return; }

            $formSelectMenus = $('.select-menu select, .ginput_container_select select');

            function isGFormInput($el) {
                return $el.hasClass('ginput_container') ? $el.parent() : $el;
            }

            function setFilled($input) {
                var $parent = isGFormInput($input.parent());

                $parent.addClass('filled');
            }

            function removeFilled($input) {
                var $parent = isGFormInput($input.parent());

                $parent.removeClass('filled');
            }

            function setFocused() {
                var $parent = isGFormInput($(this).parent());

                $parent.addClass('focused');
            }

            function removeFocused() {
                var $parent = isGFormInput($(this).parent());

                $parent.removeClass('focused');
            }

            function checkInput(e) {
                if (this.type == 'button' ||
                    this.type == 'range' ||
                    this.type == 'submit' ||
                    this.type == 'reset') { return; }

                var $this = $(this);
                var $parent = $this.parent();
                var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

                var $input = is_selectMenu ? $parent : $this;

                switch (this.type) {
                    case 'select-one':
                    case 'select-multiple':
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                    default:
                        if (this.value) {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                }
            }

            $formInputs.each(checkInput);
            $formInputs.on('change', checkInput);
            $formInputs.on('focus', setFocused);
            $formInputs.on('blur', removeFocused);
            $formSelectMenus.on('focus', setFocused);
            $formSelectMenus.on('blur', removeFocused);

        }());
    }());

    var JumpLinks = (function(){
        $dropdown = $(".jump-links--dropdown");
        $options = $dropdown.find("ul");
        $links = $options.find('a[href^="#"]');
        
        $dropdown.click(function(){
            $(this).toggleClass("active");
            $options.slideToggle();
        });
    }());

    
 

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {

            e.preventDefault();

            var iframe = $(this).data('lightbox-iframe');

            if (iframe) {
                $lightbox_content.html('<div class="iframe-wrap">' + iframe + '</div>');
            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                } else {
                    var content = $(this).next('.lightbox-content').html();
                }
                $lightbox_content.html(content);
            }

            var classes = $(this).data('lightbox-classes');
            $lightbox.addClass('active').addClass(classes);

        });

        function closeLightbox($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        $('.pdm-lightbox').on('click', function (e) {
            var $lightbox = $(this);
            if (e.target == this) {
                closeLightbox($lightbox);
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            $lightbox = $(this).closest('.pdm-lightbox');
            closeLightbox($lightbox);
        });
        return {
            close: closeLightbox
        };
    }());

    var Header = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $nav = $header.find('nav.global');
        var $headerHeight = 60;

        var isSticky = true;
        var curScrollPos;

        if (isSticky) {
            $(window).on('scroll', function () {
                curScrollPos = window.pageYOffset;
                if (window.scrollY >= $headerHeight + 40) {
                    $header.addClass('scrolled');
                   
                } else if (window.scrollY === 0) {
                    $header.removeClass('scrolled');
                }
            });
        }
        

            
                

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.menu-burger');
            var $text = $burgerMenu.find('.menu-burger__text');
            var navLinks = $header.find(".dropdown-menu .nav-link");
            var btns = $("header .btn");

            setTimeout(function(){
                console.log("timeout");
                solutionsLinks = $header.find(".solutions-menu-dropdown .nav-link");
                solutionsLinks.click(function(e) {
                    if($( window ).width() < 1200){
                        console.log("test");
                        reset();
                    }
                   
                });
            }, 10);
             
            navLinks.click(function(e) {
                if($( window ).width() < 1200){
                    console.log("test 2");
                    reset();
                }
            });

            

            btns.click(function() {
                reset();
             });

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $text.text('Close');
                $nav.addClass('active');
                $body.addClass('no-scroll');
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $text.text('Menu');
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });
        }());

        var DropdownMenus = (function () {
            var $menus = $('.menu');
            var $dropmenus = $menus.find('.dropdown.menu-item');
            var $menuLink = $menus.find(".dropdown > .nav-link");
            var $mobileArrow = $dropmenus.find('.mobile-arrow');

            function toggleDropdown(e) {
                if($( window ).width() >= 1200){
                    return;
                }
                e.preventDefault();

                var $this = $(this);
                var $menuItem = $this.closest('.dropdown');

                $dropmenus.not($menuItem).removeClass('active');

                if ($menuItem.hasClass('active')) {
                    $menuItem.removeClass('active');
                } else {
                    $menuItem.addClass('active');
                }
            }
            $menuLink.click(toggleDropdown);
            $mobileArrow.click(toggleDropdown);
        }());
    }());

    var SmoothScroll = (function () {
       
        $('a[href*="#"]').on('click', scrollPage);


        function scrollPage (e) {

            var hrefArr = this.href;
            e.preventDefault();
 
            var target = this.hash;
            var $target = $(target);
            //console.log("hash is " + this.hash);
            if(this.hash == "#" || this.hash == "") return;
            // console.log("test " + $target.offset());
            if(!$target.offset() ){
                window.location.href = this.href;
            }
 
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - 50
            }, 1200, 'swing', function () {
                //window.location.hash = target;
            });
        }
    }());

    //******************************************************Everything under this is optional, feel free to delete

    var Footer = (function () {
        
        $('footer .menu-item-has-children > a').click(function (e) {
            e.preventDefault();
            console.log("click");
            $(this).parent().toggleClass('active');
            $(this).parent().find('ul').first().slideToggle();
        });

    }());


    var featuresSlider = (function(){

        // Flickity.prototype._createResizeClass = function() {
        //     this.element.classList.add('flickity-resize');
        //   };
          
        //   Flickity.createMethods.push('_createResizeClass');
          
        //   var resize = Flickity.prototype.resize;
        //   Flickity.prototype.resize = function() {
        //     this.element.classList.remove('flickity-resize');
        //     resize.call( this );
        //     this.element.classList.add('flickity-resize');
        //   };    
        // $(this).flickity({
        //     wrapAround: true,
        //     freeScroll: true,
        //     contain: true,
        //     cellAlign:'left',
        //     // resize: false,
        //     pageDots: false
        // });
        
        var $slider = $('.features--slider .features--container');
        var settings = {
            slidesToShow: 4,
            infinite: false,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 960,
                    settings: "unslick"
                  }
            ]
        };

        $slider.each(function(){  
                $(this).slick(settings);
        });

        $(window).on('resize', function(){
            if($(window).width() < 960) return;

            if (!$slider.hasClass('slick-initialized'))
            {
                return $slider.slick(settings);
            }
        });
        
    }());

    var SolutionMenu = (function(){
        var $header = $("header");
        var solutionMenu = $header.find(".solutions-menu");
        solutionMenu.find(".dropdown-menu").remove();
        var solutionMenuNav = $header.find(".solutions-menu-dropdown");
        solutionMenu.append(solutionMenuNav.clone()); 
        var lazyImages = $('img[data-src]');
        lazyImages.each(function () {
            $(this).attr('src', $(this).data('src'));
            $(this).attr('data-src', null);
        });
    }());

    var singlePost = (function() {
        if ($('body').hasClass('single-post')) {

            $headings = $('.post-content__wrapper h2, .post-content__wrapper h3');

            if ($headings.length) {
                
                $('.toc').show();

                $("<option />", {
                    "selected": "selected",
                    "value": "",
                    "text": "Table of Content"
                  }).appendTo(".toc select"); 

                $headings.each(function () {
                    var text = $(this).text().replace(':', '');
                    var id = text.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLowerCase();
                    $(this).attr('id', id);
                    $('.toc ul').append('<li><button class="btn btn--link" data-target="' + id + '">' + text + '</button>');
                });

                $('.toc').on('click', 'button', function () {
                    //                $('.toc li.active').removeClass('active');
                    //                $(this).parent().addClass('active');
                    var target = $(this).data('target');
                    $('html, body').animate({
                        scrollTop: $('#' + target).offset().top - 100
                    }, 1000);
                });

                $(".toc select").change(function() {
                    var val = $('.toc__select :selected').val();
                    
                    if(val != ''){
                       $('html, body').animate({
                        scrollTop: $('#' + val).offset().top - 100
                        }, 1000);
                     } 
                  }); 

            }else{
                console.log("");
                $(".toc").hide();
            }

            $(window).scroll(function(){

            });


            // BACK TO TOP BUTTON 
            $('.back-to-top').click(function(){
                $('html, body').stop().animate({
                    'scrollTop': 0
                }, 1200, 'swing');
            });
            
            var scrollHeight = $(window).height();
            
            $(window).scroll(function(){
                
                var scrollAmount = $(window).scrollTop();
                
                if( scrollAmount > scrollHeight ){
                    $('.back-to-top').addClass('active');
                }else{
                    $('.back-to-top').removeClass('active');
                }
                
            });
            
        }
    }());

    var backToTop = (function(){

        
        
        
    }());

    var Blog = (function(){
        $(".category--filter .filter--btn").click(function (){
            console.log("filter clicked");
            $(".filter--bottom").toggleClass("active");
            $(".category--filter .filter").toggleClass("active");
        });

        $('.category--filter .filter').on('click', function (e) {
            if (e.target == this) {
                // $('body').removeClass('no-scroll');
                $('.filter--bottom').removeClass('active');
                $(".category--filter .filter").removeClass("active");
            }
        });
    }());

    var LoadMore = (function () {
        var $loadmore = $('#loadmore');
        if (!$loadmore.length) { return; }

        var $loadmore_text = $loadmore.text();

        $loadmore.click(function () {
            var $this = $(this);
            var $postlist = $this.siblings('.post-list');

            var query = $this.attr('data-query');
            var page = parseInt($this.attr('data-page'));
            var max = parseInt($this.attr('data-max'));

            var data = {
                action: 'load_more_posts',
                query: query,
                page: page
            };

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                beforeSend: function () {
                    $loadmore.attr('disabled', true).text('Loading Posts');
                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (res) {
                    res = JSON.parse(res);
                    var current_page = res.page;
                    var posts = res.posts;

                    if (res.status !== 'error') {
                        $loadmore.attr('disabled', false).text($loadmore_text);
                        $this.attr('data-page', current_page);
                        $postlist.append(posts);
                        lazyLoadImages.init();

                    } else {
                        $loadmore.remove();
                    }

                    if (current_page >= max) {
                        $loadmore.remove();
                    }
                }
            });
        });
    }());

});